import type { ApiBuildInfo } from '@app/packages/internalApi/types'
import { createInternalApiAction } from '@app/packages/internalApi/utils'

export const getBuildInfo = () =>
  createInternalApiAction('getBuildInfo', dispatch =>
    dispatch<{ data: ApiBuildInfo }>({
      method: 'GET',
      endpoint: '/internal/api/v1/build_info',
    })
  )
